import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Crown, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function BillingReturn() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api
      .confirmSubscription(params.get("subscription_id"))
      .then((user) => {
        setUser(user);
        toast.success("Welcome to Pro. The full choir is yours.");
        nav("/library", { replace: true });
      })
      .catch((e) => setError(errMsg(e)));
  }, [params, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080708] px-6" data-testid="billing-return-page">
      <div className="stone-panel arch-top p-10 text-center max-w-md">
        <Crown className="mx-auto text-[#D99B43]" size={32} />
        {error ? (
          <>
            <p className="font-gothic uppercase tracking-wider text-stone-100 mt-4">Payment not confirmed</p>
            <p className="text-sm text-[#E11D48] mt-2" data-testid="billing-return-error">{error}</p>
            <Link to="/#pricing" className="btn-gothic mt-6 inline-flex">Back to pricing</Link>
          </>
        ) : (
          <p className="font-cormorant italic text-xl text-stone-300 mt-4 flex items-center gap-2 justify-center">
            <Loader2 size={16} className="animate-spin" /> Confirming your subscription…
          </p>
        )}
      </div>
    </div>
  );
}
